import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/admin/form3.css'
import { loadLocationWithMessage } from '../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'

class AddNotes extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          status_submit: true,
          message: '',
          notes: '',
          appt: [],
      }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    // get clinician list //
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_appt_info',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.authReducer.uid,
        appt_id: this.props.match.params.aid,
      }
    }).then((result) => {
      this.setState({ appt: result['data'] })
    })

  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e.target.value
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    //console.log(this.state)
    if(this.state.notes === '') {
        this.setState({
          message: 'Please fill in all information',
        })
        window.scrollTo(0, 0)
    } else {
      this.setState({
        status_submit: false,
        message: '',
      })
      const appt_id =
      axios({
        method: 'post',
        url: connectNode + 'patient/general/add_notes',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          pid: this.props.authReducer.uid,
          appt_id: this.props.match.params.aid,
          notes: this.state.notes,
        }
      })
      .then((result) => {
        if(result['data'] === this.props.authReducer.uid) {
          this.props.onLoadLocation('/member/appointment_list', 'Thank you for submitting your notes!')
          this.props.history.push('/member/appointment_list')
        }
      })
    }
  }

  render() {
    return (
      <div className="admin_make_appointment box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Notes for Appointment on {this.state.appt.a_date} at {this.state.appt.appt_time}
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            <div className="box_border5">
              <form id="make_appointment" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="small-12 columns ">
                    <div className="row">
                    { this.state.message !== '' &&
                      <div className="small-12 columns warning_msg6">
                        <div className="float_left1"><WarningIcon /></div>
                        <div className="txt_warning_msg1">{ this.state.message }</div>
                      </div>}
                      <div className="small-12 columns top_space1">
                        Please jot down things you would like to discuss at your upcoming meeting.<br />
                        (These notes are for you alone; your clinician will not see them until your meeting.)
                      </div>
                      <div className="small-12 columns">
                      <TextField onChange={this.handleChange} defaultValue={this.state.notes}
                        multiline name="notes" value={this.state.notes}
                        rows={4}  maxRows={8} variant="outlined" /></div>
                    </div>
                  </div>
                </div>

                <div className="row top_space1">
                  <div className="small-12 columns text_align_right">
                    {!this.state.status_submit &&
                    <Button variant="contained" disabled
                     onClick={this.handleSubmit} type="submit">Submit</Button>}
                     {this.state.status_submit &&
                     <Button variant="contained" color="primary"
                      onClick={this.handleSubmit} type="submit">Submit</Button>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AddNotes)
